import axios from 'axios';
import { HTTP_STATIC_RESOURCES_URL } from '../config';
import { isNetworkStatusOffline, extractPropsforAxiosHttpError } from '../errors/errorhelper';
import ERRORS from '../errors/errorids';
import AppError from '../errors/apperror';
import HttpError from '../errors/httperror';
import Logger from '../logger/logger';
const log = Logger.get('staticresource');
const RETRY_TIMEOUT = 1000;
const RETRY_MAX = 5;
class StaticResource {

	get(path) {
		let requestNumber = 0;

		return new Promise((resolve, reject) => {

			const onRetry = (res) => {
				setTimeout(() => {
					doAjaxRequest(requestNumber < RETRY_MAX);
				}, RETRY_TIMEOUT);
			};

			const doAjaxRequest = (shouldRetry) => {
				requestNumber++;

				axios.get(HTTP_STATIC_RESOURCES_URL + path)
					.then(resolve)
					.catch(async (error) => {
						if (isNetworkStatusOffline(error) && shouldRetry && requestNumber <= RETRY_MAX) {
							onRetry();
						} else {

							const httpErrorProps = extractPropsforAxiosHttpError(error);
							const nError = new AppError({
								message: 'Static Resources failed',
								errorId: ERRORS.UNKNOWN,
								originalError: new HttpError(httpErrorProps),
								visualisers: { feature: 'STATIC_RESOURCE' }
							});

							log.send(nError);
							reject(nError);
						}
					});
			};

			doAjaxRequest(true);
		});
	}

}

export default new StaticResource();


// WEBPACK FOOTER //
// ./src/lib/StaticResource.js